module.exports = "/assets/b778df65e3e90fc081fe7abda1db2f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V8.png
// module id = 3036
// module chunks = 0